import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = { isSuccess: false, processing: false, courseId: null };

const enrollSlice = createSlice({
  name: "enroll",
  initialState,
  reducers: {
    pending(state, action) {
      state.processing = true;
      state.isSuccess = false;
      state.courseId = action.payload.courseId;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      /* TODO: reducer for success*/
      // state.isSuccess = true;
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
      state.isSuccess = false;
    },
    clear() {
      return initialState;
    },
  },
});

const { name, actions, reducer } = enrollSlice;
const enrollAction = createAction(name);
const clearEnrollStatusAction = actions.clear;

export {
  enrollAction,
  clearEnrollStatusAction,
  actions as enrollActions,
  reducer as enrollReducer,
};
